module.exports = __webpack_public_path__ + "static/media/blomsterstøv.fa79da10.mp3";